import { useState, useEffect, useRef } from "react";

const useGrowingText = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
        } else {
          
          timeoutRef.current = setTimeout(() => {
            setIsVisible(false);
          }, 1000); // Задержка в миллисекундах
        }
      },
      { threshold: 0.01 } // Уменьшенный порог видимости
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { containerRef, isVisible };
};

export default useGrowingText;
